module.exports = __webpack_public_path__ + "img/40_38_071_890.b140cae0.jpg";